import { bindPrototypeMethodsToSelf } from '@wix/panorama-common/utils';
import {
  PhaseName,
  type TransactionUserData,
} from '@wix/panorama-common-shared/types';
import { type BasePanoramaClient } from './panorama-client-base';

export interface PanoramaPhase {
  start: (data?: TransactionUserData) => void;
  finish: (data?: TransactionUserData) => void;
}

export class PanoramaPhaseImpl implements PanoramaPhase {
  constructor(
    private readonly name: PhaseName,
    private readonly baseClient: BasePanoramaClient,
  ) {
    this.baseClient = baseClient;

    bindPrototypeMethodsToSelf(this);
  }

  start(data?: TransactionUserData) {
    return this.baseClient.reportPhaseStart(this.name, data);
  }

  finish(data?: TransactionUserData) {
    return this.baseClient.reportPhaseFinish(this.name, data);
  }
}
